<template>
  <!-- A wrapper to allow classes on this component -->
  <div :id="`n-${id}-wrapper`">
    <component :is="'style'">
      @media {{ mediaQuery }} {
      #n-{{ id }}-fallback {
      display: block;
      }
      }
    </component>
    <component :is="'style'" v-if="withFallback">
      @media {{ mediaQuery }} {
      #n-{{ id }}-wrapper {
      min-height: 300px;
      min-width: 250px;
      }
      }
    </component>
    <div v-if="adsBlocked && withFallback" :id="`n-${id}-fallback`" class="mx-auto w-[300px] h-[250px] hidden">
      <DnsForDevelopersAd />
    </div>
    <div v-else :id="`n-${id}`" :class="[showAds ? '' : 'hidden']" />
    <div :id="`n-${id}-box`"
         :class="[showAds ? 'hidden' : '',
                  'mx-auto cursor-pointer bg-gray-300 overflow-auto font-mono',
         ]"
         @click="cycleAds"
    >
      <div v-for="(adSize, index) in adSizes" :key="index"
           :class="[
             'ml-2',
             index === selected ? 'font-bold' : '',
             index === 0 ? 'mt-2' : '',
           ]">
        {{ adSize[0] }} x {{ adSize[1] }}
      </div>
    </div>
    <component :is="'style'" v-if="!showAds && adSizes.length">
      #n-{{ id }}-box {
      display: none;
      width: {{ adSizes[selected][0] }}px;
      height: {{ adSizes[selected][1] }}px;
      }

      @media {{ mediaQuery }} {
      #n-{{ id }}-box {
      display: block;
      }
      }
    </component>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/ban-ts-comment */

import { AdSize, MediumRectangle } from '@/common/adSizes';
import store from '@/store';
import {
  computed, onMounted, PropType, ref,
} from 'vue';
import DnsForDevelopersAd from './DnsForDevelopersAd.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  adSizes: {
    type: Array as PropType<Array<AdSize>>,
    default: () => [MediumRectangle],
  },
  mediaQuery: {
    type: String,
    default: undefined,
  },
  withFallback: {
    type: Boolean,
    default: true,
  },
});

const showAds = computed(() => store.state.showAds);
const adsBlocked = computed(() => store.state.adsBlocked);
const selected = ref(props.adSizes.length - 1);
const cycleAds = () => {
  selected.value = (selected.value + 1) % props.adSizes.length;
};

if (!adsBlocked.value) {
  onMounted(() => {
    // @ts-ignore
    window.nitroAds.createAd(`n-${props.id}`, {
      refreshTime: 30,
      renderVisibleOnly: false,
      refreshVisibleOnly: true,
      sizes: props.adSizes,
      report: {
        enabled: false,
      },
      mediaQuery: props.mediaQuery,
    });
  });
}
</script>
